import React from "react";
import styles from "../styles/menus-evento.module.css";
import { fmtDate } from "../domain/dateUtils";
import MenuItem from "./MenuItem";

export default function EventoCard({
    ev,
    open,
    onToggleEvent,
    isMenuOpen,
    onToggleMenu,
}) {
    return (
        <article className={`${styles["event-card"]} ${open ? styles.open : ""}`}>
            <header className={styles["event-head"]}>
                <button
                    className={styles["event-toggle"]}
                    onClick={onToggleEvent}
                    aria-expanded={open}
                >
                    <span className={styles.chev}>▾</span>
                    <div className={styles["ev-title"]}>
                        <div className={styles.line1}>
                            {ev.nombre || `Evento #${ev.id}`}
                            <div className={styles.line2}>
                                <span className={styles.pill}>
                                    {fmtDate(ev.fechaInicio)} → {fmtDate(ev.fechaFin)}
                                </span>
                                <span className={`${styles.pill} ${styles.ghost}`}>
                                    {ev.menus?.length || 0} menú(s)
                                </span>
                            </div>
                        </div>
                    </div>
                </button>
            </header>

            {open && (
                <div className={styles["event-body"]}>
                    {ev.menus && ev.menus.length > 0 ? (
                        <ul className={styles["menu-list"]}>
                            {ev.menus.map((m, idx) => (
                                <MenuItem
                                    key={`${ev.id}-m-${idx}`}
                                    evento={ev}
                                    menu={m}
                                    idx={idx}
                                    open={!!isMenuOpen(ev.id, idx)}
                                    onToggle={() => onToggleMenu(ev.id, idx)}
                                />
                            ))}
                        </ul>
                    ) : (
                        <div className={styles["empty-inline"]}>Este evento no tiene menús.</div>
                    )}
                </div>
            )}
        </article>
    );
}
